import React from 'react';

import { Grid, Typography } from '@mui/material';
import { SelectInput, TextInput } from 'react-admin';

import booleanChoices from '../../../constants/booleanChoices';
import CommentInput from '../../comment/CommentInput';

const ListedFinancialMarket = () => (
  <Grid container spacing={2}>
    <Grid size={12}>
      <Typography
        color="#646464"
        variant="h6"
      >
        Is the company owned by a state, region, municipality or equivalent?
      </Typography>
    </Grid>
    <Grid
      size={{
        xs: 12,
        md: 4,
      }}
    >
      <SelectInput
        choices={booleanChoices.en}
        fullWidth
        source="value.option"
        label="Is the company listed on a regulated financial market?"
      />
    </Grid>
    <Grid size={12}>
      <Typography
        color="#646464"
        variant="h6"
      >
        Is the company owned by a state, region, municipality or equivalent?
      </Typography>
    </Grid>
    <Grid
      size={{
        xs: 12,
        md: 8,
      }}
    >
      <TextInput
        rows={2}
        multiline
        fullWidth
        source="value.market"
        label="On which stock exchange is the company listed?"
      />
    </Grid>
    <Grid
      size={{
        xs: 12,
        md: 8,
      }}
    >
      <CommentInput
        source="comment"
        helperText={false}
        placeholder="Please explain your decision."
      />
    </Grid>
  </Grid>

);

export default ListedFinancialMarket;
